import React from 'react';
import PropTypes from "prop-types";
import {Checkbox, Icon} from "semantic-ui-react";
import _ from "lodash";
import {connect} from "react-redux";
import {
    openEditTestcacheRecordsModal,
    selectSomeTestcache,
    toggleDeleteTestcacheRecordsModal
} from "../actions/TestcacheActions";


const COUNTRIES = require("../../common/resources/countries.json");

export class TestcacheListRow extends React.Component {

    // React's built-in state targeted to toggle the add-edit buttons on hover
    state = {
        isHovered: false,
    }

    static propTypes = {
        testcacheRecord: PropTypes.object,
        key: PropTypes.number,
        addressLine1: PropTypes.string,
        addressLine2: PropTypes.string,
        addressLine3: PropTypes.string,
        administrativeArea: PropTypes.string,
        completeName: PropTypes.string,
        countryCode: PropTypes.string,
        dataSourceType: PropTypes.string,
        dob: PropTypes.string,
        givenFullName: PropTypes.string,
        houseNumber: PropTypes.string,
        id: PropTypes.number,
        guid: PropTypes.string,
        locality: PropTypes.string,
        modifiedDate: PropTypes.string,
        nationalId: PropTypes.string,
        phone: PropTypes.string,
        postalCode: PropTypes.string,
        surnameFirst: PropTypes.string,
        thoroughfare: PropTypes.string,
        isSelected: PropTypes.bool,
    }

    handleTestcacheCheckboxSelect = (e, {checked}) => {
        this.props.selectSomeTestcache(this.props.guid, checked);
    }

    handleEditTestcacheRecord = () => {
        this.props.openEditTestcacheModal(this.props.testcacheRecord);
    }

    handleDeleteTestcacheRecord = () => {
        this.props.toggleDeleteTestcacheModal(this.props.testcacheRecord.guid);
    }

    get testcacheCheckbox() {
        return (
            <td className="low-width">
                <Checkbox
                    checked={this.props.isSelected}
                    onChange={this.handleTestcacheCheckboxSelect}
                />
            </td>
        )
    }

    get testcacheEditDelete() {
        return (
            <td
                className="low-width"
                onMouseEnter={() => this.setState({isHovered: true})}
                onMouseLeave={() => this.setState({isHovered: false})}
            >
                <div className={this.state.isHovered ? "edit-testcache-show" : "edit-testcache-hide"}>
                    <Icon link
                          name="pencil alternate"
                          size="large"
                          onClick={this.handleEditTestcacheRecord}
                    />
                    <Icon link
                          name="trash alternate outline" color="red"
                          size="large"
                          onClick={this.handleDeleteTestcacheRecord}
                    />
                </div>
            </td>
        )
    }

    get names() {
        const { givenFullName, surnameFirst } = this.props;
        return (
            <td>
                <span>{givenFullName}</span>
                <p>{surnameFirst}</p>
            </td>
        )
    }

    get addressLines() {
        const { addressLine1, addressLine2, addressLine3} = this.props;
        return (
            <td>
                <span>{addressLine1}</span>
                <p>{addressLine2}</p>
                <p>{addressLine3}</p>
            </td>
        )
    }

    get localityPlus() {
        const { houseNumber, locality, administrativeArea, postalCode, thoroughfare } = this.props;
        return (
            <td>
                <span>{houseNumber}</span>
                <p>{locality}</p>
                <p>{postalCode}</p>
                <p>{administrativeArea}</p>
                <p>{thoroughfare}</p>
            </td>
        )
    }

    get nationalID() {
        const { nationalId } = this.props;
        return (
            <td>
                {nationalId}
            </td>
        )
    }

    get dataSourceType() {
        const { dataSourceType } = this.props;
        return (
            <td>
                {dataSourceType}
            </td>
        )
    }

    get countryName() {
        const { countryCode } = this.props;
        let countryLabel = _.result(_.find(COUNTRIES, {
            'value': countryCode
        }), 'label');
        return (
            <td>
                {countryLabel}
            </td>
        )
    }

    get phoneNumber() {
        const { phone } = this.props;
        return (
            <td>
                {phone}
            </td>
        )
    }

    get dateOfBirth() {
        const { dob } = this.props;
        return (
            <td>
                {dob}
            </td>
        )
    }



    render() {

        return (
            <tr>
                {this.testcacheCheckbox}
                {this.testcacheEditDelete}
                {this.names}
                {this.addressLines}
                {this.localityPlus}
                {this.nationalID}
                {this.dataSourceType}
                {this.countryName}
                {this.phoneNumber}
                {this.dateOfBirth}
            </tr>
        )
    }
}

const mapStateToProps = (state) => ({
    all_testcache_records_selected: state.support.testcache.all_testcache_records_selected,
});

const mapDispatchToProps = dispatch => ({
    selectSomeTestcache: (recordId, isSelected) => {dispatch(selectSomeTestcache(recordId, isSelected))},
    openEditTestcacheModal: (testcacheRecord) => {dispatch(openEditTestcacheRecordsModal(testcacheRecord))},
    toggleDeleteTestcacheModal: (testcacheGUID) => {dispatch(toggleDeleteTestcacheRecordsModal(testcacheGUID))},
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TestcacheListRow)

